import { View } from 'react-native';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Icon as IconTheme } from 'src/theme-v2/icon';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { styles } from './BadgeQualityAlertV3.styles';

export const BadgeQualityAlertV3 = () => {
  const { isDesktop } = useResponsiveScreen();
  return (
    <View style={[styles.badge, isDesktop && { borderRadius: CornerRadius.Full }]} accessible={false}>
      <View style={styles.iconAlert}>
        <Icon name={ICON_NAMES.Alert} filled color={IconTheme.IconColorAlert} accessible={false} />
      </View>
    </View>
  );
};
